import { useCallback, useMemo } from 'react';

import { useAppDispatch } from '@/shared/lib/store';

import { setSelectedPattern } from '../model/slices/pattern.slice';
import type { Pattern } from '../model/types/pattern';

export const useSelectPattern = () => {
    const dispatch = useAppDispatch();

    const selectPattern = useCallback(
        (pattern: Pattern | null) => {
            dispatch(setSelectedPattern(pattern));
        },
        [dispatch],
    );

    return useMemo(
        () => ({
            selectPattern,
        }),
        [selectPattern],
    );
};
